import { Component, Input } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable, Subject, of } from 'rxjs';
import { filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { Application } from '../../../core/models/application.model';
import { ApplicationService } from '../application.service';

@Component({
  selector: 'idl-application-edit-page',
  template: `
    <mat-card appearance="outlined" *ngIf="application$ | async as application">
      <mat-card-header>
        <mat-card-title>
          <div *ngIf="addApplication; else elseBlock">Add Application</div>
          <ng-template #elseBlock>{{ application.name }} Details</ng-template>
        </mat-card-title>
        <mat-card-subtitle *ngIf="!addApplication">
          Application created: {{ application.creationdate | date: mediumDate }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <idl-application-edit
          #child
          [addApplication]="addApplication"
          [application]="application"
          [saveEvent]="saveSubject"
          (saved)="saved($event)"
        ></idl-application-edit>

        <button
          mat-raised-button
          (click)="submit()"
          [disabled]="child.appForm.invalid"
          color="accent"
        >
          <div *ngIf="addApplication; else buttonElseBlock">Create</div>
          <ng-template #buttonElseBlock>Update</ng-template>
        </button>
      </mat-card-content>
    </mat-card>
  `
})
export class ApplicationEditPageComponent {
  application$: Observable<Application>;

  @Input() addApplication = false;
  // application: Application;

  public saveSubject: Subject<void> = new Subject<void>();

  constructor(
    private _applicationService: ApplicationService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this.application$ = this._route.data.pipe(
      map(data => data.addApplication),
      mergeMap(addApplication =>
        !addApplication ? this._route.parent.paramMap : of(null)
      ),
      filter(param => param != null),
      switchMap((params: ParamMap) =>
        this._applicationService.getApp(+params.get('id'))
      )
    );
  }

  submit() {
    this.saveSubject.next();
  }

  saved(app) {
    this._applicationService.reloadApp();
    this._router.navigate(['/applications', app.applicationId]);
  }
}
